import React, { useCallback, useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from './constants/firebase';
import {db} from './constants/firebase';
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: props => ({
    margin: theme.spacing(3, 0, 2),
    background: props.palette.gradient.default
  }),
}));

export default function TeamLogo(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const { history } = props;
  const [link, setLink] = useState(props.props.link ? props.props.link : "");
  const goNext = props.props ? props.props.function: "";

  const handleSignUp = useCallback(
    async event => {
      event.preventDefault();
      const {link} = event.target.elements;
      try {
       
        var user = firebase.auth().currentUser;
        const dateObj = new Date();
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        const date = dateObj.toLocaleDateString(undefined, options)
        const time = dateObj.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        db.collection("users").doc(user.email).update({
          TeamLogo: {
            link: link.value,
            completed: true
          },
          LastUpdated: (date + " " + time)

        });

        console.log(link.value);

        goNext();
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

   const onChangeFunction = (component, value) => {
        setLink(value);
    };

   const populateValues = () => {
        console.log("in here")
        const fs = firebase.firestore()
        var user = firebase.auth().currentUser;
        fs.collection("users").doc(user.email).get()
        .then((snapshot) => {
            if (snapshot.exists) { 
            const dat  = snapshot.data()
            setLink(dat.TeamLogo.link ? dat.TeamLogo.link : "")
            } else {
            console.log("No data available");
            }
        }).catch((error) => {
            console.log("error")
        })
   }

  return (
    <ThemeProvider theme={currentTheme}>
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.paper}>
      <Typography component="h1" variant="h3">
            Team Logo
        </Typography>
        <Box marginBottom={2}>
        <Divider variant="middle" />
        </Box>
        <Typography component="h1" variant="body1">
        Please submit a public viewable link to a standardized PNG logo in both black and white and color. If any of these links are not viewable, we will email you ASAP and require that you send us updated links. If the links are not sent within our time frame, you will be subject to a fine for consideration of your application. 
        </Typography>
        <form className={classes.form} onSubmit={handleSignUp}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="link"
            label="Link"
            name="link"
            value = {link}
            onChange = {onChangeFunction}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
          >
            Submit
          </Button>
        </form>
        {/* <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={populateValues}
          >
            Not seeing anything? Retrieve Submitted Information
          </Button> */}
      </div>
    </Container>
    </ThemeProvider>
  );
}